import icons from './contentIcons.json';

/**
 * The symbols content may name, as a list rather than as free text.
 *
 * Kept as JSON for the same reason pageSlots.json is: it is read from two sides
 * that share no compiler. The application turns a key into a drawn symbol
 * (adapters/primary/ContentIcon.tsx), and scripts/generate-cms-config.js turns
 * the same list into a dropdown, so an editor picks a symbol from what exists
 * instead of typing a name that may or may not resolve.
 *
 * This module is the typed way in. Nothing else should import the JSON.
 */

export interface ContentIcon {
  /** The name the content files use. */
  key: string;
  /** What an editor sees in the editing interface. */
  label: string;
}

export const CONTENT_ICONS: ContentIcon[] = icons;

export const CONTENT_ICON_KEYS: string[] = icons.map((icon) => icon.key);
